export default __webpack_public_path__ + "static/guroux-03c01cf13b16555385a6679954881342.jpg";